export const FistCallRule = {
    "validateTelephony":"validateTelephony",
    "Logout":"Logout"
    };


// WEBPACK FOOTER //
// ./src/BusinessRule/FirstCall.js